import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

interface Chat {
  id: number;
  title: string;
  content: string;
  pinned: boolean;
}

interface ChatState {
  chats: Chat[];
  isLoading: boolean;
  error: string | null;
}

// Initial state
const initialState: ChatState = {
  chats: [],
  isLoading: false,
  error: null,
};

// Fetch chats from API
export const fetchChats = createAsyncThunk("chats/fetchChats", async () => {
  const response = await axios.get("/api/chats");
  return response.data;
});

const sidebarChatSlice = createSlice({
  name: "chats",
  initialState,
  reducers: {
    addChat: (state, action: PayloadAction<Chat>) => {
      state.chats.push(action.payload);
    },
    editChat: (state, action: PayloadAction<{ id: number; data: Partial<Chat> }>) => {
      const chat = state.chats.find((chat) => chat.id === action.payload.id);
      if (chat) {
        Object.assign(chat, action.payload.data);
      }
    },
    deleteChat: (state, action: PayloadAction<number>) => {
      state.chats = state.chats.filter((chat) => chat.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChats.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchChats.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(fetchChats.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message ?? "Failed to fetch chats";
      });
  },
});

export const { addChat, editChat, deleteChat } = sidebarChatSlice.actions;
export default sidebarChatSlice.reducer;
